import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Notifications() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Notifications
			</Text>
			<Text variant='caption' gutterBottom>
				Notifications
			</Text>
		</Paper>
	)
}
export default Notifications
